import { TableAction, DOWNLOAD } from '@/helpers/enums/table-actions'
import { KimCriteria } from '@/typings/api/CollectorPublication'

export const TABLE_ACTIONS: ReadonlyArray<TableAction<KimCriteria>> = Object.freeze([
  {
    ...DOWNLOAD,
    getFilter: ({ sha1_sum: sha1Sum }) => Boolean(sha1Sum),
  },
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Оригинальный вариант',
    value: 'original_variant',
    sortable: false,
  },
])
